import { Global } from "./Global"
import UIManager from "./UIManager"

let UMSocialPlatformType = {
    "WechatSession"      : 1, //微信聊天
    "WechatTimeLine"     : 2,//微信朋友圈
    "WechatFavorite"     : 3,//微信收藏
    "QQ"                 : 4,//QQ聊天页面
    "Qzone"              : 5,//qq空间
}

if (cc.sys.os === cc.sys.OS_ANDROID) {
    UMSocialPlatformType = {
        "WechatSession"      : 8, //微信聊天
        "WechatTimeLine"     : 9,//微信朋友圈
        "WechatFavorite"     : 10,//微信收藏
        "QQ"                 : 6,//QQ聊天页面
        "Qzone"              : 5,//qq空间
    }
}

class SDKMgr {
    UMSocialPlatformType = {
        "WechatSession"      : UMSocialPlatformType["WechatSession"], //微信聊天
        "WechatTimeLine"     : UMSocialPlatformType["WechatTimeLine"],//微信朋友圈
        "WechatFavorite"     : UMSocialPlatformType["WechatFavorite"],//微信收藏
        "QQ"                 : UMSocialPlatformType["QQ"],//QQ聊天页面
        "Qzone"              : UMSocialPlatformType["Qzone"],//qq空间
    }

    private _shareCallback = null
    private _getUserInfoCallback = null
    private _getInstallParmsCallback = null
    private _alipayCallback = null
    private _getShareInstallParmsCallback = null
    private _getShareTraceParmsCallback = null

    /**
     *
     * @param shareData 分享数据
     * @param callback 回调函数
     * @example
        SDKManager.shareURL({
            url: "http://www.baidu.com",
            platformType: SDKManager.UMSocialPlatformType.UMSocialPlatformType_WechatTimeLine,
            title: "这是标题",
            describe: "这是描述",
            thumbUrl: "https://mobile.umeng.com/images/pic/home/social/img-1.png",
        }, function (result) {
            result === 0 ? UIManager.showToastUI("分享失败", Global.ToastType.Error) : UIManager.showToastUI("分享成功", Global.ToastType.OK)
        }.bind(this));
     */
    shareURL (shareData, callback) {
        this._shareCallback = callback;

        if (cc.sys.os === cc.sys.OS_IOS) {
            jsb.reflection.callStaticMethod("SDKManager", "shareURL:addPlatformType:addTitle:addDescribe:addThumbUrl:", shareData.url, shareData.platformType, shareData.title, shareData.describe, shareData.thumbUrl);
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            jsb.reflection.callStaticMethod("org/cocos2dx/javascript/SDKManager", "shareURL", "(Ljava/lang/String;ILjava/lang/String;Ljava/lang/String;Ljava/lang/String;)V", shareData.url, shareData.platformType, shareData.title, shareData.describe, shareData.thumbUrl);
        }else {
            this._shareCallback = null
            cc.log("该方法只支持原生平台")
        }
    }

    /**
     *
     * @param platformType 平台类型 SDKManager.UMSocialPlatformType
     * @param callback 回调函数
     * @example
     * SDKManager.getUserInfo(SDKManager.UMSocialPlatformType.WechatSession, function (data) {
            cc.log(data.name)
        }.bind(this))
     */
    getUserInfo (platformType: number, callback) {
        this._getUserInfoCallback = callback

        if (cc.sys.os === cc.sys.OS_IOS) {
            jsb.reflection.callStaticMethod("SDKManager", "getUserInfo:", platformType);
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            jsb.reflection.callStaticMethod("org/cocos2dx/javascript/SDKManager", "getUserInfo", "(I)V", platformType);
        }else {
            this._getUserInfoCallback = null
            cc.log("该方法只支持原生平台")
        }
    }

    /**
     * 判断平台是否安装
     * @param platformType 平台类型 SDKManager.UMSocialPlatformType
     */
    isInstall (platformType: number): boolean {
        if (cc.sys.os === cc.sys.OS_IOS) {
            return jsb.reflection.callStaticMethod("SDKManager", "isInstall:", platformType);
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            return jsb.reflection.callStaticMethod("org/cocos2dx/javascript/SDKManager", "isInstall", "(I)Z", platformType);
        }

        return false
    }

    /**
     * 获取安装参数。调用后通过回调函数返回结果
     * @param callback 回调函数
     */
    getInstallParms (callback) {
        this._getInstallParmsCallback = callback

        if (cc.sys.os === cc.sys.OS_IOS) {
            jsb.reflection.callStaticMethod("SDKManager", "getInstallParms");
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            jsb.reflection.callStaticMethod("org/cocos2dx/javascript/SDKManager", "getInstallParms", "()V");
        }else {
            this._getInstallParmsCallback = null
            cc.log("该方法只支持原生平台")
        }
    }

    /**
     * 注册上报
     */
    reportRegister () {
        if (cc.sys.os === cc.sys.OS_IOS) {
            jsb.reflection.callStaticMethod("SDKManager", "reportRegister");
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            jsb.reflection.callStaticMethod("org/cocos2dx/javascript/SDKManager", "reportRegister", "()V");
        }else {
            cc.log("该方法只支持原生平台")
        }
    }

    /**
     * 效果点上报
     * @param effectID 效果点名称
     * @param effectValue 效果点值
     */
    reportEffectPoint (effectID: string, effectValue: number) {
        if (cc.sys.os === cc.sys.OS_IOS) {
            jsb.reflection.callStaticMethod("SDKManager", "reportEffectPoint:effectValue:", effectID, effectValue);
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            jsb.reflection.callStaticMethod("org/cocos2dx/javascript/SDKManager", "reportEffectPoint", "(Ljava/lang/String;I)V", effectID, effectValue);
        }else {
            cc.log("该方法只支持原生平台")
        }
    }

    /**
     * 获取推送的注册id
     */
    getRegistrationID (): string {
        if (cc.sys.os === cc.sys.OS_IOS) {
            return jsb.reflection.callStaticMethod("SDKManager", "getRegistrationID");
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            return jsb.reflection.callStaticMethod("org/cocos2dx/javascript/SDKManager", "getRegistrationID", "()Ljava/lang/String;");
        }else {
            cc.log("该方法只支持原生平台")
            return ""
        }
    }

    /**
     * 设置角标
     * @param num 角标数量
     */
    setBadge (num: number) {
        if (cc.sys.os === cc.sys.OS_IOS) {
            jsb.reflection.callStaticMethod("SDKManager", "setBadge:", num);
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            jsb.reflection.callStaticMethod("org/cocos2dx/javascript/SDKManager", "setBadge", "(I)V", num);
        }else {
            cc.log("该方法只支持原生平台")
        }
    }

    /**
     * 设置推送别名
     * @param alias 别名
     */
    setAlias (alias: string) {
        if (cc.sys.os === cc.sys.OS_IOS) {
            jsb.reflection.callStaticMethod("SDKManager", "setAlias:", alias);
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            jsb.reflection.callStaticMethod("org/cocos2dx/javascript/SDKManager", "setAlias", "(Ljava/lang/String;)V", alias);
        }else {
            cc.log("该方法只支持原生平台")
        }
    }

    /**
     * 删除推送别名
     */
    deleteAlias () {
        if (cc.sys.os === cc.sys.OS_IOS) {
            jsb.reflection.callStaticMethod("SDKManager", "deleteAlias");
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            jsb.reflection.callStaticMethod("org/cocos2dx/javascript/SDKManager", "deleteAlias", "()V");
        }else {
            cc.log("该方法只支持原生平台")
        }
    }

    /**
     * 设置tags（覆盖）
     * @param tags 数组转的json字符串
     */
    setTags (tags: Array<String>) {
        let tagString = JSON.stringify(tags)
        if (cc.sys.os === cc.sys.OS_IOS) {
            jsb.reflection.callStaticMethod("SDKManager", "setTags:", tagString);
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            jsb.reflection.callStaticMethod("org/cocos2dx/javascript/SDKManager", "setTags", "(Ljava/lang/String;)Z", tagString);
        }else {
            cc.log("该方法只支持原生平台")
        }
    }

    /**
     * 增加tags（不覆盖）
     * @param tags 数组转的json字符串
     */
    addTags (tags: Array<String>) {
        let tagString = JSON.stringify(tags)
        if (cc.sys.os === cc.sys.OS_IOS) {
            jsb.reflection.callStaticMethod("SDKManager", "addTags:", tagString);
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            jsb.reflection.callStaticMethod("org/cocos2dx/javascript/SDKManager", "addTags", "(Ljava/lang/String;)Z", tagString);
        }else {
            cc.log("该方法只支持原生平台")
        }
    }

    /**
     * 清除所有tags
     */
    cleanTags () {
        if (cc.sys.os === cc.sys.OS_IOS) {
            jsb.reflection.callStaticMethod("SDKManager", "cleanTags");
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            jsb.reflection.callStaticMethod("org/cocos2dx/javascript/SDKManager", "cleanTags", "()Z");
        }else {
            cc.log("该方法只支持原生平台")
        }
    }

    /**
     * 支付宝支付
     * @param orderInfo 订单信息
     * @param callback 回调函数
     */
    alipay (orderInfo: string, callback?: Function) {
        this._alipayCallback = callback

        if (cc.sys.os === cc.sys.OS_IOS) {
            jsb.reflection.callStaticMethod("SDKManager", "alipay:", orderInfo);
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            jsb.reflection.callStaticMethod("org/cocos2dx/javascript/SDKManager", "alipay", "(Ljava/lang/String;)V", orderInfo);
        }else {
            cc.log("该方法只支持原生平台")
        }
    }

    /**
     * 分享的回调函数。切记不能修改函数名和参数，否则原生不能找到该函数。
     * @param result 分享结果。0失败 1成功
     */
    onShareResult (result) {
        if (typeof this._shareCallback === "function") {
            this._shareCallback(result)
        }

        this._shareCallback = null
    }

    /**
     * 获取用户信息的回调函数。切记不能修改函数名和参数，否则原生不能找到该函数。
     * @param data 用户数据
     */
    onGetUserInfo (data) {
        if (typeof this._getUserInfoCallback === "function") {
            this._getUserInfoCallback(data)
        }

        this._getUserInfoCallback = null
    }

    /**
     * 获取安装参数的回调函数。切记不能修改函数名和参数，否则原生不能找到该函数。
     * @param data 用户数据
     */
    onGetInstallParms (data) {
        if (typeof this._getInstallParmsCallback === "function") {
            this._getInstallParmsCallback(data)
        }

        this._getInstallParmsCallback = null
    }

    /**
     * 获取拉起参数的回调函数。切记不能修改函数名和参数，否则原生不能找到该函数。
     * @param data 用户数据
     */
    onGetWakeUpParams (data) {
        cc.log("wake up parms:" + (data ? JSON.stringify(data) : ""))
        cc.director.emit(Global.UserEvent.GetWakeUpParams, data)
    }

    /**
     * 支付宝支付的回调
     * @param resultStatus resultStatus"9000"为成功
     * @param resultInfo
     */
    onAlipay (result) {
        if (typeof this._alipayCallback === "function") {
            this._alipayCallback(result)
        }

        this._alipayCallback = null
    }

    /**
     *  ShareInstall 动态获取参数调用
     */
    getShareInstallParm (callBack){

        this._getShareInstallParmsCallback = callBack

        if (cc.sys.os === cc.sys.OS_IOS) {
            jsb.reflection.callStaticMethod("SDKManager", "getShareInstallParm");
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            jsb.reflection.callStaticMethod("org/cocos2dx/javascript/SDKManager", "getShareInstallParm", "()V");
        }else {
            this._getShareInstallParmsCallback = null
            cc.log("该方法只支持原生平台")
        }
    }

    /**
     * ShareInstallSDK 回调参数
     */

    onGetShareInstall (data){

        if (typeof this._getShareInstallParmsCallback === "function") {
            this._getShareInstallParmsCallback(data)
        }

        this._getShareInstallParmsCallback = null
    }

    /**
     *  ShareInstallSDK 回传注册参数
     */
    shareInstallReportRegister () {

        if (cc.sys.os === cc.sys.OS_IOS) {
            jsb.reflection.callStaticMethod("SDKManager", "shareInstallReportRegister");
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            jsb.reflection.callStaticMethod("org/cocos2dx/javascript/SDKManager", "shareInstallReportRegister", "()V");
        }else {
            cc.log("该方法只支持原生平台")
        }
    }

    /**
     *  ShareTrace 动态获取参数调用
     */
    getShareTraceParm (callBack){
        this._getShareTraceParmsCallback = callBack
        if (cc.sys.os === cc.sys.OS_IOS) {
            cc.log("===进入getShareTraceParm");
            jsb.reflection.callStaticMethod("SDKManager", "getShareTraceParm");
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            jsb.reflection.callStaticMethod("org/cocos2dx/javascript/SDKManager", "getShareTraceParm", "()V");
        }else {
            this._getShareTraceParmsCallback = null
            cc.log("该方法只支持原生平台")
        }
    }

    /**
     * Sharetrace 回调参数
     */
    onGetShareTrace (data){
        cc.log("===sharetrace 回调参数data:",data);
        if (typeof this._getShareTraceParmsCallback === "function") {
            let dic = {}
            let paramsData: string = data.paramsData
            let params = data.paramsData.split("&")
            for (let i = 0; i < params.length; i++) {
                let param = params[i].split("=")
                dic[param[0]] = param[1]
            }
            this._getShareTraceParmsCallback(dic)
        }

        this._getShareTraceParmsCallback = null
    }
}

// 设置为全局，方便原生层回调
let SDKManager = new SDKMgr()
window["SDKManager"] = SDKManager
export default SDKManager
